import React from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { OnboardingSteps, ROUTES } from "../../utils/constants";
import FindFriendsPage from "../onboarding/FindFriendsPage/FindFriendsPage";
import GetAppPage from "../onboarding/GetAppPage/GetAppPage";
import LoginSuccessfulPage from "../onboarding/LoginSuccessfulPage/LoginSuccessfulPage";
import useOnboardingSteps from "../../hooks/useOnboardingSteps";
import { renderHeaders } from "../../utils/renderHeaders";
import JoinCommunityPage from "../onboarding/JoinCommunityPage/JoinCommunityPage";
import InstallTestflightPage from "../onboarding/InstallTestflightPage/InstallTestflightPage";

function LoginWelcomeFlowPage() {
  const { currentStep } = useOnboardingSteps();
  const { t } = useTranslation();

  let contentEl: JSX.Element;

  switch (currentStep) {
    case OnboardingSteps.LOG_IN_SUCCESSFUL:
      contentEl = <LoginSuccessfulPage />;
      break;
    case OnboardingSteps.FIND_FRIENDS:
      contentEl = <FindFriendsPage />;
      break;
    case OnboardingSteps.GET_APP:
      contentEl = <GetAppPage />;
      break;
    case OnboardingSteps.JOIN_COMMUNITY:
      contentEl = <JoinCommunityPage />;
      break;
    case OnboardingSteps.TURN_ON_NOTIFICATIONS:
      contentEl = <Navigate to={ROUTES.ROOT.DASHBOARD} replace />;
      break;
    case OnboardingSteps.INSTALL_TEST_FLIGHT:
      contentEl = <InstallTestflightPage />;
      break;
    default:
      contentEl = <FindFriendsPage />;
  }

  return (
    <>
      {renderHeaders({
        title: t("metadata:welcome_back_to_fun_games_hyper_gaming_app"),
        description: t("metadata:log_in_welcome_seo_description"),
        ogTitle: t("metadata:win_cash_in_1v1_and_multiplayer_games"),
      })}
      {contentEl}
    </>
  );
}

export default LoginWelcomeFlowPage;
